'use client';

import { Picture } from '@petsmart-ui/sparky';
import { useMemo } from 'react';

import type { PictureProps } from './type';
import { generateOptimizedPictureProps } from './utils';

export function ResponsivePicture({
    src,
    alt,
    priority = 'lazy',
    size,
    sizes,
    onMouseEnter,
    onMouseMove,
    onMouseLeave,
    className,
    qlt,
    imageComponentProps,
    ...other
}: PictureProps) {
    // sort sizes from highest to lowest because we optimize mobile first and the way picture tag works.
    const sortedSizes = sizes?.sort((a, b) => b.width - a.width);
    const { imgSrc, pictureItems } = useMemo(
        () =>
            generateOptimizedPictureProps(
                src,
                sortedSizes?.length ? sortedSizes : [size || { width: 400, height: 400 }],
                qlt
            ),
        [src, size, sortedSizes, qlt]
    );

    return (
        <>
            {priority === 'eager' && <link rel="preload" key={imgSrc} href={imgSrc} as="image" />}
            <Picture
                className={className}
                style={{ width: 'auto', height: 'auto', display: 'block' }}
                imgSrc={imgSrc}
                imgAlt={alt}
                items={pictureItems}
                imageComponentProps={{
                    loading: priority,
                    sizes: '100vw',
                    style: size ?? {},
                    ...imageComponentProps,
                }}
                onMouseEnter={onMouseEnter}
                onMouseMove={onMouseMove}
                onMouseLeave={onMouseLeave}
                data-testid="responsive-picture"
                {...other}
            />
        </>
    );
}
